import React from 'react';
import PropTypes from 'prop-types';

import Authorization from '@appComponents/Authorization';
import {ButtonAdd, ButtonExpandCollapse} from '@appComponents/ButtonCollection';
import {SECURITY_PRIVILEGES_CREATE_READ} from '@constants/variables';
import {ARGOS_JOB} from '@constants/resources';
import Link from '@appComponents/Link';

export const ArgosButtons = ({onClick, shouldExpand, showExpandCollapse, id}) => {
    return (
        <div className='indexButtons'>
            <Authorization authorization={{[ARGOS_JOB]: SECURITY_PRIVILEGES_CREATE_READ}}>
                <Link name='events.argosJobs.add' params={{id}}>
                    <ButtonAdd>Schedule new Argos job</ButtonAdd>
                </Link>
            </Authorization>
            {showExpandCollapse && (
                <ButtonExpandCollapse shouldExpand={shouldExpand} onClick={onClick} />
            )}
        </div>
    );
};

ArgosButtons.propTypes = {
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    shouldExpand: PropTypes.bool.isRequired,
    showExpandCollapse: PropTypes.bool,
};
